import styled from "styled-components";

export const WrapperLoader = styled.div`
    border: 1px solid ${({ theme }) => theme.color.concrete};
    margin: 5px;
    border-radius: 3px;
    overflow: hidden;
`;